import React, { useEffect } from 'react'

const IntroText: React.FC = () => {
	// useEffect(() => {
	// 	let introTexts = document.querySelectorAll('.intro-text--text')

	// 	introTexts.forEach((text) =>
	// 		text.addEventListener('long-press', () => {
	// 			console.log(text.innerHTML)
	// 		})
	// 	)
	// }, [])

	return (
		<h1 className='intro-text--container'>
			<span className='intro-text--text'>
				Our <span>Mother</span>,
			</span>
			<span className='intro-text--text'>
				<span>Counsellor</span>
			</span>
			<span className='intro-text--text'>
				<span>Intercessor</span>
			</span>
			<span>&</span>
			<span className='intro-text--text'>
				Our <span>Pastor</span>
			</span>
		</h1>
	)
}

export default IntroText
